<template>
  <ReferenceComponentParentList
    :searchList="result"
    :componentType="componentType"
    :selectedIndex="selectedIndex"
    :isLast="isLast"
    @onClick="onMilestoneSelected"
    @onScroll="onScroll"
  >
    <template #header>
      <BaseSubHeading
        weight="600"
        size="large"
        color="monochrome-06"
      >
        Milestones
      </BaseSubHeading>
    </template>

    <template #item="{ option }">
      <div class="reference-list__item-in">
        <span>
          <BaseSubHeading
            weight="500"
            size="large"
            color="monochrome-07"
            class="reference-list_milestone__name"
          >
            <div
              class="milestone__status-dot"
              :class="[`is-${option.status.toLowerCase()}`]"
            />
            {{ option.titleParsed }}
          </BaseSubHeading>
        </span>

        <span>
          <BaseSubHeading
            weight="400"
            size="medium"
            color="monochrome-05"
          >
            {{ getMilestoneDate(option.startDate, option.endDate) }}
          </BaseSubHeading>
        </span>
      </div>
    </template>
  </ReferenceComponentParentList>
</template>

<script lang="ts">
import { mixins, Options } from "vue-class-component"
import { Action } from "s-vuex-class"

import ReferenceComponentListCommon from "@/components/Reference/helpers/ReferenceComponentListCommon"
import ReferenceComponentParentList from "@/components/Reference/helpers/ReferenceComponentParentList.vue"

import { MilestoneSearch, SearchMilestoneResult, ServerResponse } from "@/models"
import { ReferenceType } from "@/plugins/extensions/ReferenceType"
import { Actions } from "@/store"
import { formatDate, parsingServerResponseContent } from "@/utils"

const components = {
  ReferenceComponentParentList
}

@Options({
  name: "MilestoneList",
  components
})
export default class extends mixins(ReferenceComponentListCommon) {
  @Action(Actions.SEARCH_MILESTONE) findMilestones: (
    filter: MilestoneSearch
  ) => Promise<ServerResponse<SearchMilestoneResult>>

  componentType = ReferenceType.MILESTONE
  waitTitle = "reference.search.milestone"
  result: SearchMilestoneResult[] = []
  isLast = true

  async created() {
    this.filter = new MilestoneSearch()
    this.filter.projectIds = [this.projectId]
    this.searchAction = this.onSearchMilestones
  }

  onEnterHandler() {
    if (this.result) {
      this.onMilestoneSelected(this.result[this.selectedIndex])
    }
  }

  onMilestoneSelected(payload) {
    this.selectItem({
      item: payload,
      payload: {}
    })
  }

  queryUpdated(q) {
    this.filter.q = q.substring(1)
    this.search()
  }

  getMilestoneDate(startDate, endDate) {
    const formattedStartDate = formatDate(startDate, "d MMM, yy", { dateOnly: true })
    const formattedEndDate = formatDate(endDate, "d MMM, yy", { dateOnly: true })
    return `${formattedStartDate} - ${formattedEndDate}`
  }

  async onSearchMilestones() {
    const serverResponse = await this.findMilestones(this.filter)
    if (!serverResponse) return
    this.result = parsingServerResponseContent({
      originalContent: this.result,
      serverResponseContent: serverResponse.content,
      numberOfPage: serverResponse.pageable.pageNumber
    })
    this.isLast = serverResponse.last
  }
}
</script>
